// @flow
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Button from "@mui/material/Button";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import Confirmation from "../../../../components/mui/general/confirmation/confirmation";
import { follow_up_issue } from "../../../../helpers/rights/rights";
import PermissionHOC from "../../../permission/components/permissionHOC/permissionHOC";
import useFollowUp from "../../hooks/useFollowUp";
import { ISSUES_FORM } from "../../locales/namespaces";

type Props = {
	issueId: string
};

const FollowUpButton = ({issueId}: Props) => {
	const { t } = useTranslation(ISSUES_FORM)
	const { loading: loadingFollowUp, followUp } = useFollowUp()
	const [confirm, setConfirm] = useState(false)
	const closeConfirmation = useCallback(() => (setConfirm(false)), [])
	return (
		<PermissionHOC requiredPermissions={[follow_up_issue]}>
			<Button
				size={'small'}
				variant={'contained'}
				onClick={() => setConfirm(true)}
				loading={loadingFollowUp}
				sx={{
					width: {
						xs: '100%',
						sm: 'auto'
					}
				}}
			>
				<ContentCopyIcon fontSize="small"/>
				{t('Follow Up')}
			</Button>
			<Confirmation
				open={confirm}
				handleDialog={closeConfirmation}
				onNo={closeConfirmation}
				onYes={() => {
					followUp(issueId)
				}}
				loading={loadingFollowUp}
				title={t('Confirm you wish to create a follow up ticket.')}
			/>
		</PermissionHOC>
	);
};

export default FollowUpButton